<!-- <app-spinner [show]="showSpinner" [size]="150"> </app-spinner> -->
<br /><br />
<form [formGroup]="form" style="overflow: hidden;">
  <div class="row">

    <div class="col-sm-12 col-md-5 col-lg-4">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <h2 class="webinar-title">
            Add New Webinar
          </h2>
          <small *ngIf="isInputsAllowedEditing === false" style="color: red;">
            **Only Images and Video can be updated when webinar is live.
          </small>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-form-field class="clsGapping"
                [ngStyle]="{'pointer-events': (webinarId !== undefined && webinarId > 0) ? 'none' : 'auto'}">
                <mat-label>Webinar Room </mat-label>
                <mat-select formControlName="WebinarRoom" placeholder="Please select webinar room"
                  (selectionChange)="onSelectWebinarRoom($event.value)">
                  <mat-option *ngFor="let webinarRoom of webinarRooms" [value]="webinarRoom.webinarRoomId">
                    {{webinarRoom.roomName}}</mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['WebinarRoom'].invalid">Please select webinar room</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-checkbox formControlName="IsFreeBee" style="margin-bottom: 15px;">
                Create as Freebie Webinar (No cost per seat)
              </mat-checkbox>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-form-field class="clsGapping">
                <mat-label>Webinar Product Title</mat-label>
                <input matInput type="text" formControlName="Name" maxlength="60" required>
                <mat-error *ngIf="form.controls['Name'].invalid">*Title is required</mat-error>
                <mat-error *ngIf="webinarNameInvalid">*Webinar name is already taken, please choose
                  different.</mat-error>
              </mat-form-field>
            </div>
          </div>
<!--
          <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-form-field class="clsGapping">
                <mat-label>Webinar Product Description</mat-label>
                <textarea matInput formControlName="Description" maxlength="1000"></textarea>
                <mat-error *ngIf="form.controls['Description'].invalid">*Product Description is required</mat-error>
              </mat-form-field>
            </div>
          </div>
          -->
          <div class="row" *ngIf="isInputsAllowedEditing === true">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-checkbox (change)="onChangeToRunWebinarImmediately($event)" style="margin-bottom: 15px;">
                Run Webinar Immediately
              </mat-checkbox>
            </div>
          </div>
          <div class="row" *ngIf="IsRunImmediately === false">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Webinar Date </mat-label>
                <input matInput [matDatepicker]="picker" [min]="minDate" formControlName="StartDate"
                  (click)="picker.open()" readonly>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="form.controls['StartDate'].invalid">Please select start date</mat-error>
              </mat-form-field>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Webinar Posting Time</mat-label>
                <mat-select formControlName="StartHour">
                  <mat-option *ngFor="let hour of hours" [value]="hour">
                    {{ hour }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.controls['StartHour'].invalid">Please select webinar posting time</mat-error>
              </mat-form-field>
            </div>
          </div>


          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Webinar Seats</mat-label>
                <input matInput max="200" min="1" formControlName="NumberOfSeat" (change)="SetGrossProjected()"
                  (blur)="SetGrossProjected()" required (keypress)="onlyNumbers($event)" maxlength="3" numbersonlyChecker>
                <mat-error
                  *ngIf="form.controls['NumberOfSeat'] && form.controls['NumberOfSeat'].hasError('required')">Number of
                  seats is required</mat-error>
                <mat-error
                  *ngIf="form.controls['NumberOfSeat'] && form.controls['NumberOfSeat'].hasError('min')">**Minimum seats
                  required to create webinar is 2</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field class="clsGapping" *ngIf="!form.controls['IsFreeBee'].value">
                <mat-label>Price per Seat</mat-label>
                <input matInput type="text" formControlName="Price" (change)="SetGrossProjected()"
                  (blur)="SetGrossProjected()" required maxlength="14" appTwoDecimalOnly>
                <mat-error *ngIf="form.controls['Price'].hasError('required')">Price is required.</mat-error>
                <mat-error *ngIf="form.controls['Price'].hasError('pattern')">Price can have up to 2 decimals
                  only.</mat-error>
              </mat-form-field>
              <div class="clsGapping" *ngIf="form.controls['IsFreeBee'].value" style="padding-top: 15px;">
                <label style="color: #666;">Price per Seat: $0.00 (Freebie Webinar)</label>
              </div>
            </div>
          </div>
          <!-- Duration field hidden for now - will be used for future flash webinar requirement -->
          <!-- <div class="row" *ngIf="form.controls['IsFreeBee'].value">
          <div class="col-sm-12 col-md-6 col-lg-6">
            <mat-form-field class="clsGapping">
              <mat-label>Duration (Minutes)</mat-label>
              <mat-select formControlName="DurationInMinutes" required>
                <mat-option *ngFor="let duration of durationOptions" [value]="duration">
                  {{ duration }} minutes ({{ duration < 60 ? duration + ' min' : (duration / 60).toFixed(1) + ' hours' }})
                </mat-option>
              </mat-select>
              <mat-error *ngIf="form.controls['DurationInMinutes'].hasError('required')">Please select duration</mat-error>
            </mat-form-field>
          </div>
        </div> -->
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping" style="pointer-events: none;"
                *ngIf="!form.controls['IsFreeBee'].value">
                <mat-label>Gross Projected sell</mat-label>
                <input matInput max="200" min="1" formControlName="GrossProjectedSale" readonly>
                <mat-error *ngIf="form.controls['GrossProjectedSale'].invalid">Gross Projected Sale is required
                </mat-error>
              </mat-form-field>
              <div class="clsGapping" *ngIf="form.controls['IsFreeBee'].value" style="padding-top: 15px;">
                <label style="color: #666;">Gross Projected Sale: $0.00 (Freebie Webinar)</label>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping" *ngIf="!form.controls['IsFreeBee'].value">
                <mat-label>Purchase Cost</mat-label>
                <input matInput max="200" min="1" formControlName="PurchaseCost" (keypress)="onlyDecimalAllowed($event)"
                  appTwoDecimalOnly maxlength="14" (blur)="isPurchaseCostValid()">
                <!-- <mat-error *ngIf="form.controls['PurchaseCost'].invalid">Purchase Cost is required</mat-error> -->
                <mat-error
                  *ngIf="!form.controls['IsFreeBee'].value && form.controls['PurchaseCost'].touched && form.controls['PurchaseCost'].value >= form.controls['GrossProjectedSale'].value">Purchase
                  Cost is required & must be less than Projected Sale. </mat-error>
                <mat-error *ngIf="form.controls['PurchaseCost'].hasError('pattern')">Price can have up to 2 decimals
                  only.</mat-error>
              </mat-form-field>
              <div class="clsGapping" *ngIf="form.controls['IsFreeBee'].value" style="padding-top: 15px;">
                <label style="color: #666;">Purchase Cost: $0.00 (Freebie Webinar)</label>
              </div>
            </div>
          </div>
          <div class="row" *ngIf="form.controls['NumberOfSeat'].valid">
            <div class="col-sm-12 col-md-6 col-lg-6">
              <mat-form-field class="clsGapping">
                <mat-label>Max Seats Allowed Per User</mat-label>
                <input matInput max="200" min="1" formControlName="maxSeatsAllowedPerUser"
                  (keypress)="onlyNumbers($event)" maxlength="3" (keypress)="onlyDecimalAllowed($event)">
                <mat-error
                  *ngIf="form.controls['maxSeatsAllowedPerUser'] && form.controls['maxSeatsAllowedPerUser'].hasError('min')">**Minimum
                  seat is 1.</mat-error>
                <mat-error
                  *ngIf="form.controls['maxSeatsAllowedPerUser'] && form.controls['maxSeatsAllowedPerUser'].hasError('max')">
                  **Maximum seats can be {{form.controls['NumberOfSeat'].value}}.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
           <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <mat-checkbox (change)="onChangePostOnFacebook($event)" style="margin-bottom: 15px;" formControlName="IsPostToFacebook">
                Post to your Facebook Business Page.
              </mat-checkbox>
            </div>
          </div>
        </div>

      </div>
    </div>


    <div class="col-sm-12 col-md-7 col-lg-8">
      <div *ngIf="webinarId !== undefined && webinarId !== 0 && webinarId > 0">
        <mat-checkbox (change)="onChangeIsEditImagesCheckbox()" class="isEditVideoCls">Update Webinar
          Images?</mat-checkbox> &nbsp;&nbsp;

        <mat-checkbox (change)="onChangeIsEditVideoCheckbox()" class="isEditVideoCls">Update Webinar
          Video?</mat-checkbox>
      </div>
      <div class="row"
        *ngIf="webinarId === 0 || webinarId === undefined || webinarId === null || isEditingImages || isEditingVideo">
        <div class="col-sm-12 col-md-12 col-lg-12" style="margin-bottom: 10px;">
          <div class="row">
            <div class="col-sm-12 col-md-6 col-lg-6 image-upload-section"
              *ngIf="webinarId === 0 || webinarId === undefined || webinarId === null || isEditingImages"
              style="padding-top: 10px;">
              <div *ngIf="theFile.length < 8">
                <button type="button" class="host-media-tile host-media-tile--photo" (click)="file.click()">
                  <span class="host-media-tile__icon" aria-hidden="true">
                    <svg viewBox="0 0 64 64" fill="none">
                      <rect x="6" y="16" width="42" height="34" rx="10" stroke="currentColor" stroke-width="3"/>
                      <circle cx="27" cy="33" r="9" stroke="currentColor" stroke-width="3"/>
                      <circle cx="27" cy="33" r="3.5" fill="currentColor"/>
                      <path d="M18 16l3-6h8l3 6" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                      <circle cx="50" cy="16" r="11" fill="#FFCE1B"/>
                      <path d="M50 11v10M45 16h10" stroke="#1c1008" stroke-width="2.4" stroke-linecap="round"/>
                    </svg>
                  </span>
                  <span class="host-media-tile__copy">
                    <strong>Add webinar photos</strong>
                    <em>PNG or JPG · up to 8 images</em>
                  </span>
                </button>
                <input type="file" multiple #file (change)="preview($event)" style="display:none" />
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-6"
              *ngIf="webinarId === 0 || webinarId === undefined || webinarId === null || isEditingVideo">
              <div *ngIf="!isMobileView" class="video-upload-section">
                <div *ngIf="videoBlobUrl || videoUrl" style="padding:10px; display: block; margin-bottom: 10px;">
                  <mat-icon color="warn" (click)="onDeleteVideo()" matTooltip="Delete Video"
                    style="cursor: pointer;">delete</mat-icon>
                </div>

                <div *ngIf="form.controls['TimeSlot'].value != null && form.controls['TimeSlot'].value != ''"
                  style="padding-bottom: 15px;">
                  <mat-radio-group aria-label="Select an option" formControlName="IsCameraAvailable"
                    (change)="changeRadioValue()">
                    <mat-radio-button [value]="false">Upload Video</mat-radio-button>
                    <!-- <mat-radio-button [value]="true">Record Video</mat-radio-button> -->
                  </mat-radio-group>
                </div>

                <div class="upload-button-container">
                  <ng-container *ngIf="!isCameraAvailable">
                    <button type="button" class="host-media-tile host-media-tile--video" (click)="videoFile.click()">
                      <span class="host-media-tile__icon" aria-hidden="true">
                        <svg viewBox="0 0 64 64" fill="none">
                          <rect x="8" y="14" width="34" height="36" rx="8" stroke="currentColor" stroke-width="3"/>
                          <path d="M42 24l12-6v28l-12-6V24z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
                          <circle cx="50" cy="16" r="11" fill="#FFCE1B"/>
                          <path d="M50 11v10M45 16h10" stroke="#1c1008" stroke-width="2.4" stroke-linecap="round"/>
                        </svg>
                      </span>
                      <span class="host-media-tile__copy">
                        <strong>Add webinar video</strong>
                        <em>MP4 or MOV · tap to browse</em>
                      </span>
                    </button>
                    <input type="file" id="videoFile" #videoFile (change)="getFileDetails($event)" style="display:none">
                  </ng-container>
                  <ng-container *ngIf="isCameraAvailable">
                    <a href="javascript:void(0)" *ngIf="!isVideoRecording && !videoBlobUrl"
                      (click)="startVideoRecording()" class="upload-button">
                      <i class="fa fa-video-camera"></i> Start Video Recording
                    </a>

                    <a href="javascript:void(0)" *ngIf="isVideoRecording && !videoBlobUrl"
                      (click)="stopVideoRecording()" class="upload-button" style="margin-top: 10px;">
                      <i class="fa fa-stop"></i> Stop Video Recording
                    </a>
                    <br>
                    <h1 id="videoTimer" *ngIf="isVideoRecording && !videoBlobUrl"
                      style="text-align: left; margin-top: 10px; padding-left: 10px;"> {{ videoRecordedTime }} </h1>
                  </ng-container>
                </div>
              </div>
              <div
                *ngIf="isMobileView && (webinarId === 0 || webinarId === undefined || webinarId === null || isEditingImages || isEditingVideo)">
                <div class="image-container">
                  <span *ngFor="let item of webinarImages; let i = index;">
                    <img [src]="item.image" alt="" class="icon" style="margin-right: 5px;">
                    <button mat-mini-fab color="warn" (click)="onDeleteImage(i)" style="width: 20px; height: 7px;">
                      <mat-icon>remove</mat-icon>
                    </button>
                  </span>
                </div>
                <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true" interval="5000"
                  [keyboard]="true" [pauseOnHover]="true" [wrap]="true" [animation]="false"
                  *ngIf="webinarImages.length > 0">
                  <ng-template ngbSlide *ngFor="let item of webinarImages">
                    <div class="wrapper">
                      <img [src]="item.image" alt=""
                        [ngClass]="{'ngbCarouselImg': !isMobileView, 'ngbCarouselImgMobile': isMobileView}">
                    </div>
                  </ng-template>
                </ngb-carousel>
              </div>
            </div>
          </div>
          <hr>

          <div class="col-sm-12 col-md-12 col-lg-12"
            *ngIf="webinarId === 0 || webinarId === undefined || webinarId === null || isEditingImages || isEditingVideo">
            <div class="row">
              <div class="col-sm-12 col-md-6 col-lg-6">
                <div *ngIf="!isMobileView">
                  <div class="image-container">
                    <span *ngFor="let item of webinarImages; let i = index;">
                      <img [src]="item.image" alt="" class="icon"> &nbsp;
                      <button mat-mini-fab color="warn" (click)="onDeleteImage(i)">
                        <mat-icon>remove</mat-icon>
                      </button>
                    </span>
                  </div>
                  <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true" interval="5000"
                    [keyboard]="true" [pauseOnHover]="true" [wrap]="true" [animation]="false"
                    *ngIf="webinarImages.length > 0">
                    <ng-template ngbSlide *ngFor="let item of webinarImages">
                      <div class="wrapper">
                        <img [src]="item.image" alt=""
                          [ngClass]="{'ngbCarouselImg': !isMobileView, 'ngbCarouselImgMobile': isMobileView}">
                      </div>
                    </ng-template>
                  </ngb-carousel>
                </div>
                <div
                  *ngIf="isMobileView && (webinarId === 0 || webinarId === undefined || webinarId === null || isEditingVideo)">
                  <div *ngIf="videoBlobUrl || videoUrl" style="padding:10px;">
                    <mat-icon color="warn" (click)="onDeleteVideo()" matTooltip="Delete Video"
                      style="cursor: pointer;">delete</mat-icon>
                  </div>

                  <div style="padding-bottom: 20px;">
                    <mat-radio-group aria-label="Select an option" formControlName="IsCameraAvailable"
                      (change)="changeRadioValue()">
                      <mat-radio-button [value]="false">Upload Video</mat-radio-button>
                      <!-- <mat-radio-button [value]="true">Record Video</mat-radio-button> -->
                    </mat-radio-group>
                  </div>

                  <div>
                    <ng-container *ngIf="!isCameraAvailable">
                      <button type="button" class="host-media-tile host-media-tile--video" (click)="videoFile.click()">
                        <span class="host-media-tile__icon" aria-hidden="true">
                          <svg viewBox="0 0 64 64" fill="none">
                            <rect x="8" y="14" width="34" height="36" rx="8" stroke="currentColor" stroke-width="3"/>
                            <path d="M42 24l12-6v28l-12-6V24z" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/>
                            <circle cx="50" cy="16" r="11" fill="#FFCE1B"/>
                            <path d="M50 11v10M45 16h10" stroke="#1c1008" stroke-width="2.4" stroke-linecap="round"/>
                          </svg>
                        </span>
                        <span class="host-media-tile__copy">
                          <strong>Add webinar video</strong>
                          <em>MP4 or MOV · tap to browse</em>
                        </span>
                      </button>
                      <input type="file" id="videoFile" #videoFile (change)="getFileDetails($event)"
                        style="display:none">
                    </ng-container>
                    <ng-container *ngIf="isCameraAvailable">
                      <a href="javascript:void(0)" *ngIf="!isVideoRecording && !videoBlobUrl"
                        (click)="startVideoRecording()" class="upload-button-mobile">
                        <i class="fa fa-video-camera"></i> Start Video Recording
                      </a>

                      <a href="javascript:void(0)" *ngIf="isVideoRecording && !videoBlobUrl"
                        (click)="stopVideoRecording()" class="upload-button-mobile">
                        <i class="fa fa-stop"></i> Stop Video Recording
                      </a>
                      &nbsp;
                      <h1 id="videoTimer" *ngIf="isVideoRecording && !videoBlobUrl"
                        style="text-align: left; margin-top: 10px;"> {{ videoRecordedTime }} </h1>
                    </ng-container>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-6"
                *ngIf="webinarId === 0 || webinarId === undefined || webinarId === null || isEditingVideo || videoUrl"
                [ngStyle]="{'display': (video || videoUrl) ? 'block' : 'none', 'margin-top': (isMobileView || isVideoRecording) ? '10px' : '0px'}">
                <video *ngIf="videoUrl && !isCameraAvailable" width="97%" controls [attr.src]="videoUrl" #videoPlayer
                  disabled="true" (loadedmetadata)="getDuration($event)" style="float: left;"></video>
                <video #videoElement width="97%" *ngIf="isCameraAvailable">
                  <source *ngIf="(!isVideoRecording && videoBlobUrl && isCameraAvailable)" [src]="videoBlobUrl">
                </video>
              </div>
            </div>
          </div>

        </div>

        <div class="webinar-preview-card">
          <div class="webinar-preview-card__head">
            <span class="webinar-preview-card__kicker">Live preview</span>
            <h3 class="webinar-preview-card__title">{{ form.controls['Name'].value || 'Your webinar title' }}</h3>
          </div>
          <div class="webinar-preview-card__thumb" *ngIf="webinarImages.length > 0; else noThumb">
            <img [src]="webinarImages[0].image" alt="" />
          </div>
          <ng-template #noThumb>
            <div class="webinar-preview-card__thumb webinar-preview-card__thumb--empty">
              <span>Add a photo to see it here</span>
            </div>
          </ng-template>
          <div class="webinar-preview-card__facts">
            <div>
              <span>Room</span>
              <strong>{{ selectedRoomName || '—' }}</strong>
            </div>
            <div>
              <span>Seats</span>
              <strong>{{ form.controls['NumberOfSeat'].value || '—' }}</strong>
            </div>
            <div>
              <span>Price / seat</span>
              <strong *ngIf="!form.controls['IsFreeBee'].value">${{ form.controls['Price'].value || '0.00' }}</strong>
              <strong *ngIf="form.controls['IsFreeBee'].value">Free</strong>
            </div>
            <div>
              <span>Goes live</span>
              <strong *ngIf="IsRunImmediately">Immediately</strong>
              <strong *ngIf="!IsRunImmediately">{{ (form.controls['StartDate'].value | date:'dd MMM') || '—' }}<span *ngIf="form.controls['StartHour'].value"> · {{ form.controls['StartHour'].value }}</span></strong>
            </div>
          </div>
        </div>

        <div class="webinar-tips-card">
          <h4>Before you publish</h4>
          <ul class="webinar-checklist">
            <li [class.done]="webinarImages.length > 0">
              <span class="webinar-checklist__mark">{{ webinarImages.length > 0 ? '✓' : '' }}</span>
              Add at least one photo
            </li>
            <li [class.done]="videoBlobUrl || videoUrl">
              <span class="webinar-checklist__mark">{{ (videoBlobUrl || videoUrl) ? '✓' : '' }}</span>
              Add a walkthrough video
            </li>
            <li [class.done]="form.controls['Name'].valid">
              <span class="webinar-checklist__mark">{{ form.controls['Name'].valid ? '✓' : '' }}</span>
              Give it a clear title
            </li>
            <li [class.done]="form.controls['IsFreeBee'].value || form.controls['Price'].valid">
              <span class="webinar-checklist__mark">{{ (form.controls['IsFreeBee'].value || form.controls['Price'].valid) ? '✓' : '' }}</span>
              Set your price per seat
            </li>
          </ul>
        </div>
      </div>
    </div>

    <app-facebook-post [webinar]="form.value" [imageFile]="theFile[0]" *ngIf="form.controls['IsPostToFacebook'].value === true && isShowFacebookPreview"
     (facebookPostGenerated)="onFacebookPostGenerated($event)" style="margin-left: 30px; margin-bottom: 10px;"></app-facebook-post>

    <div class="row" [ngStyle]="{'margin-top': isMobileView ? '20px' : '0px'}" style="margin-left: 15px;">
      <div class="col-sm-12 col-md-6 col-lg-6">
        <button (click)="SaveWebinar()" [ngClass]="{'upload-button': !isMobileView, 'upload-button-mobile': isMobileView}" style="margin-right: 10px;" [disabled]="isInputsAllowedEditing === false && isEditingVideo === false && isEditingImages === false">{{(webinarId !== undefined && webinarId > 0) ? 'Update' : 'Create'}}  webinar</button>
        <button (click)="Reset()" [ngClass]="{'upload-button': !isMobileView, 'upload-button-mobile': isMobileView}">Reset</button>
      </div>
    </div>
  </div>
</form>